import React, { useState } from 'react';
import { db } from '../firebase';
import { collection, getDocs, doc, writeBatch } from 'firebase/firestore';

export default function MigrateDB() {
  const [log, setLog] = useState([]);
  const [running, setRunning] = useState(false);

  const addLog = (msg) => setLog(prev => [...prev, msg]);

  const runMigration = async () => {
    setRunning(true);
    addLog("Starting migration...");
    try {
      const schoolsSnap = await getDocs(collection(db, 'schools'));
      let totalMigrated = 0;

      for (const schoolDoc of schoolsSnap.docs) {
        const schoolId = schoolDoc.id;
        addLog(`Processing school: ${schoolId}`);

        const userPermsRef = collection(db, 'schools', schoolId, 'user_permissions');
        const userPermsSnap = await getDocs(userPermsRef);

        if (userPermsSnap.empty) {
          addLog(`No user_permissions found for school ${schoolId}`);
          continue;
        }

        const batch = writeBatch(db);
        let batchCount = 0;

        for (const permDoc of userPermsSnap.docs) {
          const data = permDoc.data();
          const role = data.Role || '';
          
          let targetCollection = 'staff_profiles';
          if (role === 'student') {
            targetCollection = 'student_profiles';
          }

          const profileRef = doc(db, 'schools', schoolId, targetCollection, permDoc.id);
          
          const payload = {
            role: role,
            firstName: data.firstName || '',
            lastName: data.lastName || '',
            schoolId: schoolId,
            email: data.email || permDoc.id
          };

          batch.set(profileRef, payload, { merge: true });
          batchCount++;
        }

        if (batchCount > 0) {
          await batch.commit();
          addLog(`Migrated ${batchCount} records for school ${schoolId}`);
          totalMigrated += batchCount;
        }
      }

      addLog(`Migration complete! Total records migrated: ${totalMigrated}`);
    } catch (err) {
      addLog(`Migration failed: ${err.message}`);
    }
    setRunning(false);
  };

  return (
    <div style={{ padding: '2rem' }}>
      <h1>DB Migration</h1>
      <button 
        onClick={runMigration} 
        disabled={running}
        style={{ padding: '0.5rem 1rem', fontSize: '1rem', cursor: 'pointer', marginBottom: '1rem' }}
      >
        {running ? 'Running...' : 'Run Migration'}
      </button>
      <div style={{ background: '#000', color: '#0f0', padding: '1rem', minHeight: '300px', fontFamily: 'monospace' }}>
        {log.map((l, i) => <div key={i}>{l}</div>)}
      </div>
    </div>
  );
}
